import { MedRecSwitch, SearchHeader, StoreLocator } from '@/components';
import { PAGE_ROUTES } from '@/constants';

import {
  HeaderFavorites,
  HeaderLogo,
  HeaderNav,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

import styles from './default.module.scss';

const HeaderDefaultDesktop = () => (
  <>
    <HeaderRow type="medium">
      <HeaderSection justify="start">
        <HeaderLogo />
        <StoreLocator />
        <MedRecSwitch />
      </HeaderSection>
      <HeaderSection justify="end">
        <SearchHeader
          className={styles.search__header}
          seeAllHref={PAGE_ROUTES.SHOP}
        />
        <HeaderProfile />
        <HeaderFavorites />
        <HeaderShopping />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow type="flat" withNavbar>
      <HeaderSection justify="start">
        <HeaderNav />
      </HeaderSection>
    </HeaderRow>
  </>
);

export { HeaderDefaultDesktop };
